export const SystemDeviceTypesIds = {
  Camera: '6b8273f1-e602-4da1-86d9-4d333d1fd6b9',
  DC: 'f914c225-70b2-4b4c-b0c6-cd13d82316d6',
  Gateway: 'de4aaec1-dcd4-472f-85ad-0848fdb71f83',
  'Network Port': 'db1f385f-09f3-4b17-b683-17a1fcf46ff5',
  'Network Switch': 'c4e8d9c4-f51d-4c3c-ae3d-85a340a3d04c',
  Outlet: 'c1c030d7-f5a9-4992-b152-c0361b7afa2a',
  OutletPDU: '5f62550f-88c7-4ef8-9e0b-ed443b5ad67e',
  Port: 'db1f385f-09f3-4b17-b683-17a1fcf46ff5',
  PowerDistributionUnit: '85599afc-8a42-4b48-96ff-7cfd5760c309',
  Switch: 'c4e8d9c4-f51d-4c3c-ae3d-85a340a3d04c',
};

export const SystemMakersIds = {
  AVServices: '5f62f8e6-3f1d-4d0a-9a0f-bc3e9a11a6c4',
  Crestron: 'fa365459-b9df-4e42-9f7e-a578d462a9b0',
  Generic: '7f4a0d4e-0a19-4c5e-8c3f-70a2fc84fef6',
  Harmony: '7c2f6d9a-4b3e-4f6a-9c7a-1b8e2d6a5f44',
  Samsung: 'cc12322e-7682-4470-9a3e-66947ed004f5',
};

export const SystemModelsIds = {
  OutletPDU: 'ca750968-420f-4dfb-84b9-bce5f285e6f8',
  Port: 'b812de6b-b793-4dc4-b716-29b318b2f626',
};

export enum PDUOutletTypes {
  PORT_4 = 4,
  PORT_8 = 8,
  PORT_12 = 12,
  PORT_16 = 16,
}

export enum SwitchPortTypes {
  PORT_12 = 12,
  PORT_16 = 16,
  PORT_24 = 24,
  PORT_48 = 48,
  PORT_60 = 60,
}
